import React, { useEffect, useState, useCallback } from "react";
import {
  customerListId,
  addToCard,
  addProductToList,
} from "../../../server/ShoppingList";
import { useParams } from "react-router-dom";
import showAlert from "../../../server/ShowAlert";
import { getCart } from "../../../server/CollectSite";
import { setPreload } from "../../../server/CartsOpen";
import { useDispatch, useSelector } from "react-redux";
import { handleCartResponse } from "./UserShoppingList";
const UserShoppingListProduct = ({ setProductPopUp, setSelectedProd }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const productsInCart = useSelector(
    (state) => state.productsInCart?.productsInCart ?? [],
  );
  const stationId = useSelector((state) => state.user?.stationId);
  const [products, setProducts] = useState(null);
  const [listName, setListName] = useState("טוען רשימה...");
  const [listId, setListId] = useState("");

  const getProductList = useCallback(() => {
    console.log("id on customerListId", id);
    customerListId(id, stationId)
      .then((x) => {
        if (x.data) {
          setListId(x.data.id);
          setListName(x.data.name);
          setProducts(x.data.items ?? []);
          console.log("customerList", x.data);
        }
      })
      .catch((e) => {
        if (e.response.status === 404) {
          setListName("הרשימה לא נמצאה");
          showAlert({ msgTitle: "הרשימה לא נמצאה", msgType: "error" });
        }
        console.log(e);
      });
  }, [id, stationId]);

  useEffect(() => {
    getProductList();
  }, [getProductList]);
  const AddToCard = () => {
    if (!products || products.length === 0) {
      showAlert({
        msgTitle: "אין מוצרים ברשימה",
        msgType: "error",
      });
      return;
    }

    addToCard(stationId, products, productsInCart)
      .then((x) => {
        if (!x.data) {
          showAlert({
            msgTitle: "הייתה בעיה בהוספת הרשימה לעגלת קניות",
            msgType: "error",
          });
          return;
        }
        const reservedItems = x.data?.reservedItems || [];
        handleCartResponse(
          reservedItems,
          products,
          dispatch,
          stationId,
          showAlert,
          getCart,
          x.data?.allFailed,
        );
      })
      .catch((e) => {
        console.error(e);

        if (e.response?.status === 409 || e.response?.status === 400) {
          showAlert({
            msgTitle: "המוצרים אינם זמינים במלאי",
            msgType: "error",
          });
        } else {
          showAlert({
            msgTitle: "שגיאה בהוספה לעגלה",
            msgType: "error",
          });
        }
      });
  };

  const AddToShopList = (quantity, productId, suppressAlert = false) => {
    dispatch(setPreload(true));

    addProductToList(listId, productId, quantity)
      .then((response) => {
        if (!response.data) {
          showAlert({ msgTitle: "הייתה בעיה בעדכון הרשימה", msgType: "error" });
          return;
        }

        if (response.data.status === "DELETED") {
          setProducts(products.filter((item) => item.productId !== productId));
          showAlert({ msgTitle: "המוצר נמחק מהרשימה", msgType: "error" });
        } else if (response.data.status === "UPDATED") {
          const updatedProducts = products.map((item) =>
            item.productId === productId ? { ...item, quantity } : item,
          );

          setProducts(updatedProducts);
          if (!suppressAlert) {
            showAlert({ msgTitle: "הכמות השתנה", msgType: "success" });
          }
        }
      })
      .catch(() => {
        showAlert({ msgTitle: "שגיאה בשרת, נסה שנית", msgType: "error" });
      })
      .finally(() => dispatch(setPreload(false)));
  };

  const openProduct = (prod) => {
    console.log("prod", prod);
    setSelectedProd(prod.product);
    setProductPopUp(true);
  };
  const handleQuantityChange = (value, productId) => {
    const qty = Math.max(1, parseInt(value) || 1);
    const updatedProducts = products.map((p) =>
      p.productId === productId ? { ...p, quantity: qty } : p,
    );
    setProducts(updatedProducts);
  };

  const handleQuantityBlur = (productId, quantity, weightJump) => {
    if (quantity % weightJump !== 0) {
      const rounded = Math.round(quantity / weightJump) * weightJump;
      const finalQty = Math.max(weightJump, rounded);
      showAlert({
        msgTitle: `המוצר נמכר בקפיצות של ${weightJump} יחידות, הכמות עודכנה ל-${finalQty}`,
        msgType: "info",
      });
      AddToShopList(finalQty, productId, true);
    } else {
      AddToShopList(quantity, productId, false);
    }
  };

  return (
    <div className="shopping-list-product">
      {listName ? (
        <div>
          <h1>{listName}</h1>
          {products?.length > 0 ? (
            <div>
              <table>
                <tbody>
                  <tr>
                    <th>שם המוצר</th>
                    <th>כמות</th>
                    <th></th>
                  </tr>
                  {products.map((prod) => {
                    const weightJump =
                      parseInt(prod.product?.weightJump) > 0
                        ? parseInt(prod.product.weightJump)
                        : 1;

                    return (
                      <tr key={prod.productId} className="shopping-list-row">
                        <td>
                          <a
                            href="/"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              openProduct(prod);
                            }}
                          >
                            {prod.product ? prod.product.name : prod.productId}
                          </a>
                        </td>
                        <td>
                          <input
                            type="number"
                            value={prod.quantity}
                            onChange={(e) =>
                              handleQuantityChange(
                                e.target.value,
                                prod.productId,
                              )
                            }
                            onBlur={(e) =>
                              handleQuantityBlur(
                                prod.productId,
                                Math.max(
                                  weightJump,
                                  parseInt(e.target.value) || weightJump,
                                ),
                                weightJump,
                              )
                            }
                            min={weightJump}
                            step={weightJump}
                          />
                        </td>
                        <td>
                          <button
                            className="btn"
                            onClick={() => AddToShopList(0, prod.productId)}
                          >
                            מחק מוצר
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div>
                <button className="btn" onClick={AddToCard}>
                  הוספה לסל קניות
                </button>
              </div>
            </div>
          ) : (
            products && <h2>אין פריטים ברשימה</h2>
          )}
        </div>
      ) : (
        <h1>אין רשימה להצגה</h1>
      )}
    </div>
  );
};

export default UserShoppingListProduct;
